import { createAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { FETCH_TASK_SAGA, DELETE_TASK_SAGA, DELETE_SUB_TASK_SAGA, CREATE_SUB_TASK_SAGA, CREATE_DEPENDENCY_SAGA, DEPENDENCY_CREATED_SAGA, DEPENDENCY_REMOVED_SAGA, CREATE_MULTIPLE_SUB_TASKS_SAGA, REMOVE_AS_SUBTASK, REMOVE_AS_SUBTASK_SUCCESS, DEPENDENCIES_REMOVED_SAGA, UPDATE_SPRINT_SAGA, RESET_ENTITY_DATES, DEPENDENCIES_OPERATIONS_SAGA, DEPENDENCY_CREATION_THROUGH_TIMELINE, BULK_DEPENDENCY_DELETION_FOR_PHASES_AND_TASKS_FROM_TIMELINE, DELETE_DEPENDENCY_RELATIONS_SAGA, ADD_TASK_BELOW_SAGA, ADD_SUB_TASK_SAGA, BULK_UPDATE_WBS_SAGA, REMOVE_TEMPORARY_TASK_SAGA } from './types';
export const updateSprintSagaAction = createAction(UPDATE_SPRINT_SAGA);
export const fetchTaskSaga = createAction(FETCH_TASK_SAGA);
function withPayloadType() {
    return (t)=>({
            payload: {
                ...t,
                taskId: moment().valueOf()
            }
        });
}
function withMutipleSubTasksPayloadType() {
    return (t)=>({
            payload: {
                ...t,
                subtasks: t.subtasks.map((subtask, index)=>({
                        taskName: subtask.taskName,
                        taskId: moment().valueOf() + index
                    }))
            }
        });
}
export const createSubTaskSagaAction = createAction(CREATE_SUB_TASK_SAGA, withPayloadType());
export const createMultipleSubTasksSagaAction = createAction(CREATE_MULTIPLE_SUB_TASKS_SAGA, withMutipleSubTasksPayloadType());
export const deleteTaskSagaAction = createAction(DELETE_TASK_SAGA);
export const deleteSubTaskSagaAction = createAction(DELETE_SUB_TASK_SAGA);
export const removeAsSubtaskSagaAction = createAction(REMOVE_AS_SUBTASK);
export const removeAsSubtaskSuccessAction = createAction(REMOVE_AS_SUBTASK_SUCCESS);
export const createDependencySagaAction = createAction(CREATE_DEPENDENCY_SAGA);
export const dependencyCreatedAction = createAction(DEPENDENCY_CREATED_SAGA);
export const dependencyRemovedAction = createAction(DEPENDENCY_REMOVED_SAGA);
export const dependenciesRemovedAction = createAction(DEPENDENCIES_REMOVED_SAGA);
export const bulkDependencyDeletionForPhasesAndTasksFromTimelineSagaAction = createAction(BULK_DEPENDENCY_DELETION_FOR_PHASES_AND_TASKS_FROM_TIMELINE);
export const dependenciesOperationsAction = createAction(DEPENDENCIES_OPERATIONS_SAGA);
export const resetEntityDatesAction = createAction(RESET_ENTITY_DATES);
export const dependencyCreationThroughTimeline = createAction(DEPENDENCY_CREATION_THROUGH_TIMELINE);
export const deleteDependencyRelationsSagaAction = createAction(DELETE_DEPENDENCY_RELATIONS_SAGA);
export const addTaskBelowSagaAction = createAction(ADD_TASK_BELOW_SAGA);
export const addSubTaskSagaAction = createAction(ADD_SUB_TASK_SAGA);
export const removeTemporaryTaskSagaAction = createAction(REMOVE_TEMPORARY_TASK_SAGA);
export const bulkUpdateWbsSagaAction = createAction(BULK_UPDATE_WBS_SAGA);
export const boardTaskSavedAction = createAction('tasks/boardTaskSaved');
